export const leadPipeline = {
  title: 'Lead pipeline',
  addLead: 'Add lead',
  researchNotes: 'Research notes',
  researchNotesPlaceholder: "What we've listened to / why this feels right",
  promoteToPartner: 'Promote to Partner',
  stages: {
    noticing: 'Noticing',
    noticingDescription: "You've identified them. Initial research only.",
    listening: 'Listening',
    listeningDescription: "You've engaged with their work — read their content, attended something, understand what they care about.",
    reaching: 'Reaching',
    reachingDescription: 'First outreach sent. Waiting.',
    'in-conversation': 'In Conversation',
    inConversationDescription: 'Active dialogue. Not yet a formal inquiry.',
    dormant: 'Dormant',
    dormantDescription: 'Not right now, but worth returning to.',
  },
  sectors: {
    heritage: 'Heritage',
    'arts-org': 'Arts organisation',
    council: 'Council',
    'nhs-trust': 'NHS trust',
    university: 'University',
    cultural_organisation: 'Cultural organisation',
    community_org: 'Community org',
    charity: 'Charity',
    educational: 'Educational',
    government: 'Government',
    private_company: 'Private company',
    media: 'Media',
    other: 'Other',
  },
  form: {
    name: 'Name / organisation',
    nameRequired: 'Name / organisation is required.',
    sector: 'Sector',
    website: 'Website',
    contactName: 'Contact name',
    contactEmail: 'Contact email',
    draftEmail: 'Draft email',
    draftEmailPlaceholder: 'Subject: ...\n\nEmail body...',
    openInMail: 'Open in Mail',
    sendEmail: 'Send email',
    sending: 'Sending…',
    sendEmailSuccess: 'Email sent.',
    sendEmailError: 'Failed to send email.',
    sendEmailMissing: 'Add a contact email and draft to send.',
    createLead: 'Create lead',
    saveChanges: 'Save changes',
    editLead: 'Edit lead',
    stage: 'Stage',
    deleteLead: 'Delete lead',
  },
  deleteConfirm: {
    title: 'Delete lead',
    message: 'This lead will be removed from the pipeline. This cannot be undone.',
  },
  errors: {
    deleteFailed: 'Failed to delete lead. Please try again.',
  },
  sort: {
    label: 'Sort',
    nameAsc: 'Name A–Z',
    nameDesc: 'Name Z–A',
    sector: 'Sector',
    createdDesc: 'Recently added',
  },
  promoteDialog: {
    title: 'Promote to Partner',
    description: 'Create a partner record from this lead. Fill in contact details below.',
    createProjectInquiry: 'Create project inquiry',
    primaryContactName: 'Primary contact name',
    primaryContactEmail: 'Primary contact email',
    primaryContactRequired: 'Primary contact name and email are required.',
    success: 'Lead promoted to partner.',
    viewPartnershipDashboard: 'View Partnership Dashboard',
  },
  card: {
    emailSentToday: 'Email sent today',
    emailSentDaysAgo: 'Email sent {{count}} days ago',
  },
  emptyState: {
    title: 'No leads in this stage',
    description: 'Add a lead or drag one here from another column.',
  },
  nav: {
    leadPipeline: 'Lead pipeline',
    partnerships: 'Partnerships',
    leadPipelineDescription: 'Track potential partners before they become inquiries',
  },
};
